import React from 'react';
import { Link } from 'gatsby';
import { Box } from '@hover/blueprint';
import { ArrowButton } from '@hover/shared-components';

const LearnMoreButton: React.FC = () => (
  <Box w="100%" justifyContent="center">
    <ArrowButton
      as={Link}
      to="/blog/?from=insurance"
      mt={700}
      alignSelf="center"
      w={{ base: '323px', tablet: 'auto' }}
      colorScheme="primary"
      justifyContent="center"
      display="inline-flex" // do not remove: important to preserve solid button style
    >
      Learn More
    </ArrowButton>
  </Box>
);

export default LearnMoreButton;
